export const HU = {
  message: {
    banner:
      "Due to a technical issue, all the data cannot be published. We are working on it. We apologise for the inconvenience.",
    in: "In",
    loadingText: "Betöltés...",
    selectCustomer: "válasszon ügyfelet",
    offline: "Karbantartás alatt álló oldal",
    refer: "Lásd a HASZNÁLATI ÚTMUTATÓT",
    error: {
      userNotFound: "User not found",
      noToken: "This link is no longer valid",
    },
    alert: {
      mail: "Enable mail alert",
      sms: "Enable SMS alert",
      battery: "battery alerts",
      disclamer:
        "based on thresholds defined by Akiem Leasing and concerning locomotives fitted with Railster boxes",
      sralert: "Riasztás",
      toggleAlert:
        "Ennek az opciónak az aktiválásával e-mail értesítést kap minden MyFleetHub által kiküldött figyelmeztetésrő",
      quotation: "Quotation alert",
      quotationLabel:
        "ha aktiválja ezt az opciót, e-mai értesítést kap minden egyes, a MyFleetHubon közzétett új árajánlatról",
    },
    select: "Select all",
    ssoLogin: "SignIn with Azure AD",
    rgpd:
      'Az Akiem elkötelezett a személyes adatok védelmére vonatkozó jogszabályok, különösen az általános adatvédelmi rendelet ("GDPR")' +
      " tisztességes és átlátható módon történő betartása mellett. Ezen a portálon nem használunk sütiket. Így a bejelentkezési munkamenet" +
      " során nem gyűjtjük az Ön személyes adatait, és a munkamenet befejezése után sem tároljuk azokat. Kifejezett beleegyezését kérjük, " +
      'ha használni kívánja az "elégedettségi felmérés" funkciót.',
    login: {
      welcomeFirst: "üdvözöljük az (Ön) ",
      welcomeSecond: "to the customer area",
      id: "Login",
      pw: "Password",
      restore: "Reset my password",
      validate: "Validate",
      errorLogin: "The password is wrong please try again",
      initMsg:
        "Please enter your password to finalize the creation of your account",
    },
    aside: {
      home: "Home",
      notice: "Használati útmutató",
      logout: "Kapcsolat bontása",
      account: "Fiókom",
      config: "Configuration",
      profil: "Profilinformációk",
      alert: "My alerts",
      parc: "Az én járműparkom",
      planning: "My schedule",
      detail: "Flottám részletes adatai",
      geo: "Berendezésem földrajzi helyének meghatározása",
      board: "Irányítópult",
      km: "Követett km",
      hm: "Motor üzemideje",
      battery: "Battery Info",
      mint: "My MINT",
      magic: "Karbantartási Beavatkozások",
      history: "Előzmények",
      infoloc: "Loco information",
      attachment: "Add an attachment",
      fleetcontrol: "Flottaellenőrzés",
      unleased: "Nem lízingelt flotta",
      doc: "Dokumentumaim",
      edl: "Berendezések leltára / Tanúsítványok",
      certificat: "Tanúsítványok",
      jobplan: "Karbantartás esedékes dátumok",
      krefeldplan: "Krefeld plan",
      batterytable: "Latest battery readings",
      geofencing: "Geofencing",
      disponibility: "Szerződéses elérhetőség",
      admin: "Internal menu",
      locoInternal: "Hozzon létre egy hotline jegyet",
      userlist: "Felhasználói lista",
    },
    superuser: {
      profile: "Profil",
      action: "Action",
      updateprofile: "Kiadás",
      administrator: "Adminisztrátor",
      management: "Menedzsment",
      operational: "Operatív",
      commercial: "Kereskedelmi",
      delmessage1: "Ön a",
      delmessage2:
        "fiók törlését kívánja kérni. Üzenetet küldünk az Akiem informatikai részlegének, amely törli a fiókot.",
      delmessage3:
        "a továbbiakban nem fér hozzá a My Fleet hub ügyfélportálhoz. Ha a felhasználó egy későbbi időpontban újra létre kívánja hozni a fiókot, akkor forduljon a szolgáltatási szerződésért felelős vezetőjéhez. Szeretné folytatni?",
      legendmgt:
        "A menedzsmentprofil az összes portálmodulhoz hozzáférhet. Ők érvényesíthetik a többletmunkát.",
      legendcom:
        "Az értékesítési profil az összes portálmodulba betekinthet. Ők nem tudnak többletmunkát érvényesíteni.",
      legendoper:
        "Az operatív profil a portál összes modulját megtekintheti, kivéve az « én extra munkám » modult.",
    },
    geofencing: {
      select: "Please select a value",
      entry: "Entry date and time",
      exit: "Exit date and time",
      dbenergy: "Have you thought about making your DB energy declaration?",
    },
    header: {
      language: "Languages",
    },
    home: {
      team: "Az én elkötelezett Akiem csapatom",
      name: "Name",
      firstname: "First name",
      function: "Function",
      fixphone: "Fixed line phone",
      mobilephone: "Mobile phone",
      mail: "E-mail",
      locoInfo: "Gyors szervizkérelem létrehozása",
    },
    page: {
      assignment: "Megbízás",
      customer: "Customer",
      portal: "Portal",
      availableLoco: "karbantartja AKIEM",
      loconumber: "Mozdonyok száma",
      status: "üzemi státusz",
      available: "Rendelkezésre áll",
      maintenance: "Karbantartás alatt",
      connexionDate: "Legutóbbi belépés dátuma",
      findLocation: "Gördülőállomány helyének meghatározása",
      contractNumber: "Szerződésszám",
      serial: "Sorozatszám",
      contractStatus: "Szerződéses státusz",
      startDate: "Kezdő dátum",
      endDate: "Záró dátum",
      delta: "Egyetlen mozdony kiválasztásával megkapja az útvonalat",
      locate: "Helymeghatározás",
      titular: "Tulajdonos",
      reserve: "Tartalék",
      spot: "Helyszín",
      performance: "Teljesítmény",
      cumulTitle: "Cumulative kilometers per locomotive",
      cumul: "Km halmozott",
      moyMonth: "átlagos megtett kilométer / hónap",
      distance: "Távolság",
      filterMsg: "Egyetlen mozdony kiválasztásával megkapja az útvonalat",
      availableNotice: '"Does not include notices"',
      doctype: "A dokumentum típusa",
      contractType: "Contract type",
    },
    opinionGlobal: {
      opinion: "Véleményem a portálról",
      opinionFirst: "Véleményem",
      opinionSecond: "a portálról",
      opinionRedirectionOne: "Ön egy külső oldalra kerül átirányításra,",
      opinionRedirectionTwo: "szeretné folytatni ?",
      opinionClic:
        "Erre a linkre kattintva Ön beleegyezik, hogy elhagyja ezt a portált, hogy hozzáférjen az Eval N Go platformhoz, " +
        "az elégedettségi felméréshez, és így hozzájárul személyes adatainak feldolgozásához.",
      opinionPersonelData:
        "A szükséges és gyűjtött személyes adatok a következők :",
      opinionMail: "E-mail címek",
      opinionName: "Név",
      opinionDataTransmission:
        "Ezeket az adatokat csak az Akiem által felhatalmazott, titoktartási kötelezettséggel rendelkező személyeknek továbbítjuk, " +
        "és 1 évig tároljuk.",
      opinionStock:
        "A tárhely Franciaországban található, és az adatok nem kerülnek továbbításra az EU-n kívülre.",
      opinionRules:
        "A hatályos törvények értelmében Önnek joga van személyes adatai ellenőrzéséhez (hozzáférés, helyesbítés stb.), " +
        " amelyet a dpo@akiem.com címre küldött e-mailben gyakorolhat.",
      opinionHelp:
        "Ez segít nekünk, hogy tovább fejlődjünk abban, ahogyan Önt támogatjuk, és hogy jobban megértsük az Ön igényeit, " +
        "ezért az Ön hozzájárulása értékes segítség lenne.",
      opinionYes: "Igen",
      opinionNo: "Nem",
    },
    pageKm: {
      trackingKm: "Mileage tracking",
      tableKm: "Mileage table",
      status: "Szerződéses státusz",
      serial: "Sorozatszám",
      contract: "Contracts",
      contractnum: "Szerződésszám",
      total: "Távolság összesen",
      loco: "Mozdonyok",
      date: "Dates",
      since: "Ettől a naptól",
      kmNotice: '"Kilometers surveyed according to Railster data submitted " ',
    },
    pageHm: {
      title: "Motor üzemideje",
      lastcheck: "Latest data",
      cumulativeHm: "Cumulative engine hours",
      hm: "Engine hours",
      total: "A motorok teljes üzemideje",
      portalReal: "Readings taken from the portal",
      maintenanceReal: "Readings taken during maintenance",
      detailHm: "A motor üzemidejének",
    },
    maintenance: {
      workshops: "Karbantartó műhelyek",
    },
    pageAlert: {
      alert: "My alerts",
      inout: " LOCOMOTIVE ENTRY AND EXIT",
      serial: "On a series",
      contract: "On a contract",
      loco: "On the locs in my fleet",
      mail: "Activate mail alerts",
      sms: "Activate sms alerts",
      battery: "BATTERY ALERTS",
    },
    passwordResetPage: {
      first:
        "Please enter your username and password to complete the creation of your account",
      confirm: "password confirmation",
      pwRuleOne: "password required",
      pwRuleTwo: "minimum 8 characters",
      pwRuleThree:
        "Password must contain at least lowercase letter, one number, a special character and one uppercase letter",
      pwConfirmOne: "password confirmation is required",
      pwConfirmTwo: "Password confirmation does not match",
      pwSuccess: "Password reset with success",
      validate: "Validate",
    },
    pageNotice: {
      second:
        "A portálon megjelenő és/vagy a portálon keresztül elérhető adatok, információk és/vagy dokumentumok kizárólag tájékoztató" +
        " jellegűek, és nem rendelkeznek szerződéses értékkel.",
      third:
        "Ezek az adatok, információk és/vagy dokumentumok pontatlanságokat és hibákat tartalmazhatnak. Ezeket az Akiem bármikor " +
        "módosíthatja, és frissítheti. Erősen ajánlott ellenőrizni a portálon elérhetővé tett adatok, információk és/vagy dokumentumok pontosságát és helytállóságát.",
      fourty:
        "A jelen weboldalon elérhető adatok, információk és/vagy dokumentumok felhasználásáért kizárólag a weboldal felhasználója felelős, aki vállalja az ebből " +
        "eredő összes következményt, anélkül, hogy az Akiem e tekintetben felelősségre vonható lenne, és anélkül, hogy az Akiemmel szemben jogorvoslatot kérhetne.",
      fifty:
        "Az Akiem nem tehető felelőssé semmilyen kárért, amely a weboldalon elérhető információk és/vagy dokumentumok értelmezéséből vagy felhasználásából ered.",
      sixty:
        "A weboldal általában a nap 24 órájában, a hét 7 napján elérhető a Felhasználók számára, akik rendelkeznek internet-hozzáféréssel, " +
        "kivéve vis maior vagy az Akiem hatókörén kívül eső esemény esetén, valamint üzemzavarok és a weboldal megfelelő működéséhez szükséges és karbantartási műveletek függvényében." +
        "Az Akiem fenntartja a jogot, hogy a karbantartás biztosítása érdekében vagy bármely más okból bármikor, előzetes értesítés nélkül megszakítsa vagy ideiglenesen felfüggessze " +
        "vagy módosítsa a weboldal egészéhez vagy egy részéhez való hozzáférést, anélkül, hogy ez a megszakítás bármilyen kötelezettséget vagy kártérítést vonna maga után.",
      seventy:
        "Az Akiem vállalja, hogy tisztességes és átlátható módon betartja a személyes adatok védelmére vonatkozó jogszabályokat, különösen az általános adatvédelmi rendeletet (GDPR)." +
        "Az Akiem technikai és szervezési intézkedéseket hozott annak érdekében, hogy a felhasználó adatai védve legyenek a jogosulatlan hozzáféréssel, " +
        "valamint bármely más biztonsági kockázattal és informatikai sebezhetőséggel szemben.",
      eighty:
        "Ezen a portálon nem használunk sütiket. Ezért az Ön személyes adatait nem gyűjtjük a bejelentkezési munkamenet során, és nem tároljuk a munkamenet befejezése után." +
        ' Kifejezett külön beleegyezést kérünk Öntől, ha használni kívánja az "elégedettségi felmérés" funkciót.',
    },
    magic: {
      workorderTitle: "Beavatkozás megnevezése",
      workorder: "Beavatkozás",
      startDate: "Kezdő dátum",
      endDate: "Záró dátum",
      meter: "Kilométer",
      hours: "motor óraszám",
      technicDoc: "Műszaki dokumentáció",
      restriction: "Restriction/Reason",
      date: "Dátum",
      asset: "Asset",
      km: "KM",
      leftD1: "Left D1",
      leftD2: "Left D2",
      leftD3: "Left D3",
      leftD4: "Left D4",
      rightD1: "Right D1",
      rightD2: "Right D2",
      rightD3: "Right D3",
      rightD4: "Right D4",
      action: "Action",
      description: "Összefoglaló - hely",
      desc: "Összefoglaló",
      addFile: "Melléklet hozzáadása",
      reportBy: "Report By",
      id: "ID",
      status: "Státusz",
      sr: "Jelzés",
      srAttechement: "Kapcsolódó jelzések",
      attachements: "Mellékletek",
      mileage: "Adatsorok",
      createAlert: "Jelzés létrehozása",
      title: "Cím",
      location: "Hely",
      priority: "Prioritás",
      addKm: "Egy mérés közlése",
      newKm: "új érték",
      lastreading: "Aktuális érték",
      scheduleDate: "Tervezési dátumok",
      metername: "Mérés típusa",
      executeDate: "Végrehajtási dátumok",
      error: "Sikertelen művelet",
      success: "A művelet rögzítésre került",
      unit: "Egység",
      source: "Forrás",
      jobplan: "Job plan type",
      type: "Típus",
      reportedDate: "Létrehozás dátuma",
      details: "Részletek",
      hotline: "Forróvonal jegy",
    },
    assetStatus: {
      operating: "Operating",
      maintenance: "Maintenance",
      limitedUse: "limited use",
      blocked: "Blocked",
    },
    button: {
      submit: "Jóváhagyás",
      cancel: "Törlés",
    },
    search: "Keresés",
    history: {
      pm: "Korábbi megelőző beavatkozások",
      cm: "Korábbi javító beavatkozások",
    },
    infoloc: {
      infoOp: "Üzemi információk",
      infoTech: "Műszaki információk",
      cert: "Jóváhagyások",
      openSr: "Open service request",
      sr: "Kapcsolódó jelzések",
      dateAndKm: "Dátumok és kilométerek",
      pmPlan: "Preventive maintenance plan",
      locomotive: "Mozdonyok",
      actWorkorder: "Beavatkozás folyamatban",
      outPrevDate: "Előzetes megjelenési dátum",
      nextWorkDate: "Következő karbantartás",
      wheelset: "Tengelyinformációk",
      unitToGo: "Hátralévő kilométerek",
      engineeringvariant: "Engineering variant",
      softwareversion: "Software version",
      hkm: "kilométer-előzmények",
      hhm: "motor üzemórák története",
      fuellevel: "Fioul szint",
      parking: "Feszültség nélkül",
      traction: "Mozgásban - vontatásban",
      vehicle: "Mozgásban - vontatott",
      poweron: "be, nincs mozgás",
      standby: "Dízel motor be -nincs mozgás",
    },
    status: {
      approved: "Confirmed appointment",
      canceled: "Törölve",
      ccanceled: "Appointment canceled by customer",
      completed: "Status according desicion ECM 3",
      inprogress: "Under maintenance",
      wait: "forcast planing, upcoming maintenance",
      new: "ÚJ",
      sinprogress: "Folyamatban",
      closed: "Verschließen",
    },
    woStatus: {
      WSCH: "A tervezés során",
      WAPPR: "A tervezés során",
      WPCOND: "A tervezés során",
      CLOSE: "Befejezett",
      COMP: "Befejezett",
      INPRG: "Folyamatban",
      REVIEWED: "Végrehajtva / ECM3 kiadás folyamatban",
      WCOE: "A pótalkatrészek árának függvényében",
      WMATL: "A pótalkatrészek árának függvényében",
      APPR: " Jóváhagyva ECM4",
      CA: "Törölt",
      NOTPERF: "Nincs végrehajtva",
      CAN: "Törölt",
    },
    doc: {
      certificat: {
        delivry: "Szállítási bizonyítványok",
        redelivry: "Visszatérési bizonyítványok",
        genralInfo: "GENERAL INFORMATION",
        technicalInfo: "TECHNICAL DATA",
        signature:"SIGNATURES",
        asOf:"As of ",
        andAccording: "and in accordance with the provisions",
        contractRes: "contract/reservation ",
        representBy:"the company Akiem SAS represented by Sebastian Rodriguez",
        delivryTo: "delivers to the company",
        delivryToAkm:"has delivered to Akiem represented by Sebastian Rodriguez ",
        locomotive: "the locomotive",
        delivryAt: "delivered to the site of ",
        restDerog:"Restrictions/ limited used",
        comment:"Comments",
        edl:"Hand over document attached",
        remark:"Note",
        rem1:"Subject to contractual provisions, this locomotive must be insured from the date of delivery shown on the certificate at the latest.",
        rem2:"Custody of the locomotive passes to the lessee on the delivery date stated in this certificate",
        kmCompteur: "Km odometer",
        hmMoteur: "Engine hours",
        wheelset: "Axles",
        recentData: "most recent data*",
        lastRecord: "last recorded on ",
        date:"Date",
        defaultMes:"If no reservation is received within 48 hours, this certificate will be considered final..",
        addBill:"You may be billed for any additional costs incurred in refurbishing the locomotive. ",
        yes: "YES",
        no: "NO",
        reserv: "To send a reserve",
        reject: "Reserves issued"
      },
      type: "A dokumentum típusa",
      edl: {
        delivry: "Szállítási nyilatkozat",
        redelivry: "Szállítási nyilatkozat ",
      },
    },
    doctypes: [
      {
        key: "DELIVERY (EXCEPT NEW)",
        value: "Szállítási nyilatkozat",
      },
      {
        key: "REDELIVERY,RESTITUTION",
        value: "Szállítási nyilatkozat",
      },
      {
        key: "Prima Delivery Certificate,Traxx Delivery Certificate",
        value: "Szállítási bizonyítványok",
      },
      {
        key: "Prima Redelivery Certificate,Traxx Redelivery Certificate",
        value: "Visszatérési bizonyítványok",
      },
    ],
    poi: {
      workshop: "Entrance/Exit Workshop",
      entry: "Estimated entry on",
      exit: "Exit estimated on",
      at: "at",
    },
    extrawork: {
      title: "My Extra-works",
      newquote: "új idézetek",
      quotewaiting: "érvényesítésre várnak",
      messageconfirm: "Kérjük, adja meg a rendelés számát",
      confirm: "erősítse meg a  címet.",
      reject: "Contest",
      cancel: "cancel",
      whyreject: "Miért kívánja elutasítani az árajánlatot?",
      rejectcomment: "kérjük, hagyjon egy megjegyzést",
      quotenum: "Ajánlatszám.",
      quotetitle: "árajánlat címe",
      quoteprice: "Ára nem tartalmazza az árat.",
      quotestatus: "Ajánlat státusza",
      realisationdate: "Tényleges megvalósítás",
      customerpo: "Vevő Po",
      tovalidate: "érvényesítésre vár",
      validated: "Elfogadva",
      rejected: "Elutasítva",
      quoterejected: "Elutasítva",
      quotesrejected: "Elutasított árajánlatok",
      comment: "Comment",
      unitprice: "Egységárak",
      service: "Szolgáltatások",
      quantity: "Mennyiség",
      totalprice: "Teljes ár",
      quotetotalprice: "Az árajánlat teljes költsége",
      statusbilled: "kiszámlázott",
      statusvalidated: "érvényesített",
    },
    dispoc: {
      past: "átadott megbízások megtekintése",
      widgetText: "Lásd a szerződéses elérhetőségemet",
      taux: "Aránya",
      recapLoc: "Elérhetősége",
      ticmp: "Megelőző leállások aránya",
      timcc: "Javítási leállási idő aránya",
      ticc: "ügyfélleállás aránya",
      locDisp: "Elérhető",
      locTot: "Összességében",
      week: "Hét",
      ldispo: "Elérhető",
      ldmd: "Csökkentett üzemmódban elérhető",
      lmp: "Megelőző karbantartás",
      lmc: "Korrekciós karbantartás",
      lach: "útvonaltervezés",
      lmcc: "Ügyfél javító karbantartás",
      indisponibilite: "Elérhetetlenség",
      dispGen: "Globális rendelkezésre állás",
      causeCorrective: "javító karbantartás",
      causePreventive: "megelőző karbantartás",
      causeClient: "ügyfél",
    },
  },
};

export default HU;
